import { useParams, Navigate, Link, useSearchParams } from "react-router-dom";
import { blogs } from "../../data/Blog.data";

export default function BlogDetailPage() {
  const { slug } = useParams();
  const blog = blogs.find((b) => b.slug === slug);
  const [searchParams] = useSearchParams()

  const origin = searchParams.get('origin')
  if (!blog) {
    return <Navigate to="/blogs" replace />;
  }

  return (
    <section className="relative overflow-hidden rounded-b-lg bg-[#F2F4F7]">

      <div className="relative z-10 mx-auto max-w-4xl px-6 ">

        {/* Header */}
        <header className="mt-8 text-center">
          <p className="text-sm text-gray-500">{blog.date}</p>

          <h1 className="mt-3 text-lg font-bold tracking-tight text-gray-900 sm:text-3xl">
            {blog.title}
          </h1>

          <p className="mx-auto mt-6 max-w-2xl text-lg text-gray-600">
            {blog.excerpt}
          </p>
        </header>

        {/* Featured image */}
        {blog.image && (
          <div className="mt-14 overflow-hidden rounded-2xl shadow-sm">
            <img
            src={`${blog.image}-800.jpg`}
            srcSet={`${blog.image}-480.jpg 480w, ${blog.image}-800.jpg 800w`}
            sizes="(max-width: 768px) 100vw, 33vw"
            alt={blog.title}
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover"
            />
          </div>
        )}

        {/* Content */}
        <article
          className="
            prose prose-gray mx-auto mt-16 max-w-none
            prose-h2:mt-12 prose-h2:text-2xl
            prose-p:leading-relaxed
          "
          dangerouslySetInnerHTML={{ __html: blog.content }}
        />

        {/* Divider */}
        <div className="my-16 h-px w-full bg-gray-200" />

        {/* Footer CTA */}

      </div>
    </section>
  );
}
